<div class="row mt-xl-5">
  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
    <h3 class="headings">Bank Accounts</h3>
  </div>
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-right pt-1 exp-m" >
    <button class="customf_btn mr-4" (click)="openHistory()">History</button>
    <button class="customf_btn" (click)="changeBankAccount()">Change Bank Account</button>
  </div>
</div>
<!--<app-details-loader [Height]="'70vh'" [LoaderMarginTop]="'19%'"-->
<!--                    *ngIf="loadFlag || errorMsg" [errorMsg]="errorMsg"></app-details-loader>-->
<div class="event-bdy">
  <div class="table_content mt-4">
    <div class="row">
      <div class="col-md-12 col-xs-12 mob_no_padding">
        <div (scroll)='scrollcontent("TopScroll", "scrollContent")' *ngIf="!loadFlag" class="top-scroll" id="TopScroll">
          <img src="" height=1 [style]="checkTablewidth()">
        </div>
        <div class="table-responsive table-height"    (scroll)='scrollcontent("scrollContent", "TopScroll")'  id="scrollContent">
          <app-message-on-list *ngIf="!loadFlag && errorMsg" [message]="errorMsg" [iconName]="'warning'"></app-message-on-list>
          <table *ngIf="!errorMsg" class="table m-0" id="table-width">
            <thead>
            <tr>
              <th class="account_number"><a (click)="setSorting('account_number')">Account
                <i class="fa fa-thin" [ngClass]="orderBy === 'account_number' ? stylesortBy : 'fa-angle-down'"></i>
              </a></th>
              <th class="routing_number"><a (click)="setSorting('routing_number')">Routing Number
                <i class="fa fa-thin" [ngClass]="orderBy === 'routing_number' ? stylesortBy : 'fa-angle-down'"></i>
              </a></th>
              <th class="used_for"><a (click)="setSorting('used_for')">Used For
                <i class="fa fa-thin" [ngClass]="orderBy === 'used_for' ? stylesortBy : 'fa-angle-down'"></i>
              </a></th>
              <th class="status"><a (click)="setSorting('status')">Status
                <i class="fa fa-thin" [ngClass]="orderBy === 'status' ? stylesortBy : 'fa-angle-down'"></i>
              </a></th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="loadFlag">
              <tr class="loader">
                <td colspan="7">
                  <div class="loader-container">
                    <img class="table-loader" src="../../../assets/images/loading.svg" />
                  </div>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="!loadFlag && bankAccountList.data.length > 0">
              <tr class="cus_list" *ngFor="let reject of bankAccountList.data">
                <td class="account_number" data-th="AccountNumber">
                  <a [routerLink]="redirect_link" [queryParams]="{ id: reject.id }"
                     [innerHTML]="highlight( reject.bank_account_number)">
                  </a>
                </td>

                <td class="routing_number" data-th="Client ID">
                  <a [routerLink]="redirect_link" [queryParams]="{id: reject.id} "  [innerHTML]="highlight(reject.routing_number)">
                  </a>
                </td>
                <td class="used_for" data-th="User Email">
                  <a [routerLink]="redirect_link" [queryParams]="{id: reject.id} "  [innerHTML]="highlight(reject.used_for)">
                  </a>
                </td>
                <td class="status" data-th="Status">
                  <i class="fa fa-circle "
                     [ngClass]="['Pending change'].includes(reject.status)
                          ? 's_pending'
                          : ['Active'].includes(reject.status)
                            ? 's_active'
                            : 's_canceled'"
                     aria-hidden="true"></i>
                  <a [routerLink]="redirect_link" [queryParams]="{id: reject.id} "  [innerHTML]="highlight(reject.status)">
                  </a>
                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
        <div class="row m-0 pt-sm-4 pt-2 border-2" *ngIf="!loadFlag && bankAccountList.data.length > 0">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mb-5" *ngIf="metadata['total']">
              <span class="paginate">
                {{ 1 + (metadata['current_page'] - 1) * limit }} -
                <select [(ngModel)]="limit" (change)="limitChange()" class="page-limit"
                        *ngIf="metadata['current_page'] === 1">
                  <option *ngFor="let no of limitArray" [value]="no">{{
                      no
                    }}</option>
                </select>
                <span *ngIf="metadata['current_page'] !== 1">{{
                    metadata['count'] +
                    (metadata['current_page'] - 1) * limit
                  }}</span> &nbsp;of &nbsp;{{ metadata['total'] }}
              </span>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 text-lg-right text-left px-m-0 px-md-m-0">
            <ul class="list-inline"  *ngIf="!loadFlag && bankAccountList.data.length > 0 && objectKeys(metadata.links).length > 0">
              <li  class="list-inline-item"><button type="button" class="btn btn-default btn_prenext" [disabled]="!metadata.links['previous']"
                                                    (click)="paginate( metadata.links['previous'])">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i> Previous
              </button></li>
              <li class="list-inline-item" *ngFor="let number of numbers()">
                <div *ngIf="+number.toString() ">
                  <a class="page-link" *ngIf="metadata.links.next" [ngClass]="{ 'paginate_active': metadata['current_page'] === number }"
                     (click)="nextpage(number, metadata.links.next)" >{{number}}</a>
                  <a class="page-link" *ngIf="metadata.links['previous'] && metadata['current_page'] > (metadata['total_pages'] - 1)" [ngClass]="{ 'paginate_active': metadata['current_page'] === number }"
                     (click)="nextpage(number, metadata.links['previous'])" >{{number}}</a>
                </div>
                <a class="page-link" *ngIf="!+number.toString()" >{{number}}</a>
              </li>
              <li  class="list-inline-item" ><button type="button" class="btn btn-default btn_prenext" [disabled]="!metadata.links['next']"
                                                     (click)="
                  paginate(metadata.links['next']) ">
                Next  <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </button></li>
            </ul>


          </div>
        </div>
      </div>
    </div>
  </div>
</div>
